import React from 'react';
import { UeElement } from '@oneaudi/falcon-tools';
import type { Link } from '../../../ContentType';
import { useTrackingManager } from '../../../utils/useTrackingManager';
import { StyledTextButton } from '../SubPageNavigationStyles';
import { useBreakpoint } from '../../../utils/useBreakpoint';

interface CtaProps extends Link {
  variant: 'primary' | 'secondary';
  label: string;
  property: string;
  disabled?: boolean;
  role?: string;
}

const CtaButton: React.FC<CtaProps> = ({
  href,
  text,
  ariaLabel,
  opensInNewTab,
  variant,
  label,
  property,
  disabled,
  role,
}) => {
  const { click } = useTrackingManager();
  const { breakpoint } = useBreakpoint();

  const buttonProps = disabled
    ? { disabled: true }
    : { href, target: opensInNewTab ? '_blank' : '_self' };

  return (
    <StyledTextButton
      variant={variant}
      isFullWidth
      size="sm"
      role={role}
      {...buttonProps}
      onClick={() => {
        click('cta', text, href, '', breakpoint, variant);
      }}
      {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
    >
      <UeElement type="text" label={label} property={property}>
        {text}
      </UeElement>
    </StyledTextButton>
  );
};

export const CtaPrimary: React.FC<Link> = ({
  href,
  text,
  ariaLabel,
  opensInNewTab,
  disabled,
  role,
}) => (
  <CtaButton
    href={href}
    text={text}
    ariaLabel={ariaLabel}
    opensInNewTab={opensInNewTab}
    variant="primary"
    label="Primary CTA (optional) - Label"
    property="cta_text"
    disabled={disabled}
    role={role}
  />
);

export const CtaSecondary: React.FC<Link> = ({
  href,
  text,
  ariaLabel,
  opensInNewTab,
  disabled,
  role,
}) => (
  <CtaButton
    href={href}
    text={text}
    ariaLabel={ariaLabel}
    opensInNewTab={opensInNewTab}
    variant="secondary"
    label="Secondary CTA (optional) - Fill in for a Custom Secondary CTA (optional) - Label"
    property="secondaryCta_customCta_text"
    disabled={disabled}
    role={role}
  />
);
